import {getAuth} from "firebase/auth";


export const bearerTokenProvider = {
    getToken : async (forceRefresh = false) => {
        const currentUser = getAuth().currentUser;
        return currentUser != null ? await currentUser.getIdToken(forceRefresh) : "";
    }
}
